import { CheckIcon } from '@langchain/untitled-ui-icons';
import { Button } from '@mui/joy';

import { FC } from 'react';

import PaginationTabs from '../PaginationTabs';

type TProps = {
  isCurrentPrompt: boolean;
  isMutating: boolean;
  numArtifacts: number;
  viewingArtifactIndex: number;
  setViewingArtifactIndex: (index: number) => void;
  handleSetPrompt: () => void;
  handleGoToCurrent: () => void;
  setShowDiff: (show: boolean) => void;
};

const VersionManager: FC<TProps> = ({
  isCurrentPrompt,
  isMutating,
  numArtifacts,
  viewingArtifactIndex,
  setViewingArtifactIndex,
  handleSetPrompt,
  handleGoToCurrent,
  setShowDiff,
}) => {
  const handleDisableDiff = (newPage) => {
    if (newPage === 0) {
      setShowDiff(false);
    }
  };

  const renderPromptButton = () => {
    if (isCurrentPrompt) {
      return (
        <div className="border-success-primary flex flex-row items-center gap-1 rounded-md border bg-success-primary p-1">
          <CheckIcon className="text-success-primary h-4 w-4" />
          <span className="text-success-primary text-sm font-medium">
            Current version
          </span>
        </div>
      );
    }
    return (
      <div className="flex flex-row items-center gap-1">
        <Button
          variant="outlined"
          color="neutral"
          size="sm"
          onClick={() => {
            handleGoToCurrent();
          }}
        >
          <span className="font-light">Go to current</span>
        </Button>
        <Button onClick={handleSetPrompt} disabled={isMutating} size="sm">
          <span>Use this version</span>
        </Button>
      </div>
    );
  };

  return (
    <div className="mb-2 flex grow flex-row items-end justify-between gap-2 pb-1 pt-2">
      <div className="flex flex-row items-center gap-4">
        <PaginationTabs
          currentIndex={viewingArtifactIndex}
          setCurrentIndex={setViewingArtifactIndex}
          isMutating={isMutating}
          numPages={numArtifacts}
          onPageChange={handleDisableDiff}
        />
      </div>
      <div className="self-end">{renderPromptButton()}</div>
    </div>
  );
};

export default VersionManager;
